module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "container"
  }, [_c('h1', {
    staticClass: "title is-2"
  }, [_vm._v("About Phil")]), _vm._v(" "), _c('div', {
    staticClass: "columns"
  }, [_c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-content"
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', [_vm._v("Phil Makepeace is an experienced and highly regarded coach who has been teaching chess full-time since 2013. He was England Under 18 Captain in 2007 having played in his first tournament at age 6. Phil is known as a combative, tactical player who loves a sacrifice.")]), _vm._v(" "), _c('p', [_vm._v("Outside of chess, Phil is a long-suffering Wycombe Wanderers supporter and thinks egg sandwiches are a sin.")]), _vm._v(" "), _c('p', [_vm._v("Since moving to London in 2009, Phil has taught chess in nearly twenty primary and secondary schools. His students have achieved tournament successes both individually and representing their schools.")])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Qualifications")]), _vm._v(" "), _c('ul', {
    staticClass: "bio-list"
  }, [_c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2019")]), _vm._v("Certified by Wandsworth Council on completion of Safeguarding Children in Education course")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2014")]), _c('a', {
    attrs: {
      "href": "http://www.englishchess.org.uk/coaches/ecf-coaches/",
      "target": "_blank"
    }
  }, [_vm._v("ECF Accredited Coach")])])])]), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('h2', {
    staticClass: "subtitle is-4"
  }, [_vm._v("Chess achievements")]), _vm._v(" "), _c('ul', {
    staticClass: "bio-list"
  }, [_c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2022")]), _vm._v("Chess consultant for the Hollywood film "), _c('a', {
    attrs: {
      "href": "https://m.imdb.com/name/nm13595086",
      "target": "_blank"
    }
  }, [_vm._v("Morbius")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2020")]), _vm._v("Co-founder and weekly panellist on "), _c('a', {
    attrs: {
      "href": "https://audioboom.com/channels/5017754",
      "target": "_blank"
    }
  }, [_vm._v("The Chess Pit podcast")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2017")]), _c('a', {
    attrs: {
      "href": "https://www.youtube.com/watch?v=Km8bMzCOhWc",
      "target": "_blank"
    }
  }, [_vm._v("Media and publicity manager")]), _vm._v(" at the "), _c('a', {
    attrs: {
      "href": "http://www.britishchesschampionships.co.uk/photography-2017/",
      "target": "_blank"
    }
  }, [_vm._v("British Chess Championships")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2013")]), _vm._v("Beat a Grandmaster in a slowplay game for the first time")]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2010")]), _c('a', {
    attrs: {
      "href": "http://www.saund.co.uk/britbase/pgn/201007britchamp-viewer.html",
      "target": "_blank"
    }
  }, [_vm._v("Runner-up in British Under 21 Championship")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2007")]), _c('a', {
    attrs: {
      "href": "http://www.icu.ie/articles/150",
      "target": "_blank"
    }
  }, [_vm._v("England Under 18 Captain")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2006 & 2007")]), _c('a', {
    attrs: {
      "href": "http://www.sccu-chess.com/archive/champs.htm",
      "target": "_blank"
    }
  }, [_vm._v("Southern Counties Junior Champion")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2005, 2006 & 2007")]), _c('a', {
    attrs: {
      "href": "http://www.buckschess.org.uk/Individuals/index.html",
      "target": "_blank"
    }
  }, [_vm._v("Bucks Senior Champion")])]), _vm._v(" "), _c('li', [_c('span', {
    staticClass: "year"
  }, [_vm._v("2001 - 2007")]), _vm._v("Represented the England Junior Squad in Lithuania, Czech Republic, Poland, USA and Ireland")]), _vm._v(" "), _c('br'), _vm._v(" "), _c('li', [_vm._v("Phil has held a peak ECF grade of 2195 and live "), _c('a', {
    attrs: {
      "href": "https://ratings.fide.com/card.phtml?event=413550",
      "target": "_blank"
    }
  }, [_vm._v("FIDE rating")]), _vm._v(" of 2116")])])])])])]), _vm._v(" "), _c('div', {
    staticClass: "column is-6"
  }, [_c('div', {
    staticClass: "card"
  }, [_c('div', {
    staticClass: "card-image"
  }, [_c('figure', {
    staticClass: "image"
  }, [_c('img', {
    attrs: {
      "src": require("../assets/CoachesPhil.png"),
      "alt": "Phil Makepeace"
    }
  })])])])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0031c1d1","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AboutPhil.vue
// module id = 37
// module chunks = 0